<div class="min-h-screen-safe bg-westetics-neutral-100 flex flex-col">
  <!-- Cabeçalho -->
  <header class="bg-westetics-purple-800 text-white p-4 shadow-md">
    <div class="container mx-auto flex justify-center items-center">
      <img src="assets/icons/mini-logo-v2.svg" alt="Logo" class="h-8 w-8 object-contain brightness-0 invert mr-3">
      <h1 class="text-xl font-bold">Upload de Fotos de Tratamento</h1>
    </div>
  </header>

  <!-- Conteúdo principal -->
  <main class="flex-grow container mx-auto px-4 py-6">
    <!-- Indicador de carregamento -->
    <div *ngIf="loading" class="flex justify-center items-center py-12">
      <app-loading-spinner size="lg"></app-loading-spinner>
      <span class="ml-3 text-gray-700">Carregando...</span>
    </div>

    <!-- Conteúdo quando carregado -->
    <div *ngIf="!loading">
      <!-- Mensagem de erro -->
      <div *ngIf="errorMessage" class="mb-6 bg-red-100 border-l-4 border-red-500 text-red-700 p-4 rounded-md">
        <div class="flex items-start">
          <div class="flex-shrink-0">
            <i class="fas fa-exclamation-circle text-red-500"></i>
          </div>
          <div class="ml-3">
            <p class="text-sm font-medium">{{ errorMessage }}</p>
          </div>
        </div>
      </div>

      <!-- Mensagem de sucesso -->
      <div *ngIf="uploadComplete" class="mb-6 bg-green-100 border-l-4 border-green-500 text-green-700 p-4 rounded-md">
        <div class="flex items-start">
          <div class="flex-shrink-0">
            <i class="fas fa-check-circle text-green-500"></i>
          </div>
          <div class="ml-3">
            <p class="text-sm font-medium">{{ successMessage }}</p>
            <p class="text-sm mt-1">Você pode fechar esta página agora. As fotos foram enviadas com sucesso!</p>
          </div>
        </div>
      </div>

      <!-- Instruções -->
      <div *ngIf="!uploadComplete" class="mb-6 bg-westetics-purple-100 px-4 py-4 rounded-md border border-westetics-purple-200">
        <h2 class="text-lg font-semibold mb-2">Instruções:</h2>
        <p class="text-sm text-gray-700 mb-4">
          Tire ou selecione fotos para documentar o tratamento do paciente:
        </p>
        <ul class="text-sm text-gray-700 mb-3 list-disc pl-5 space-y-1">
          <li *ngIf="!photoTypeParam || photoTypeParam === 'MARKING'">Fotos de <strong>marcação</strong> (marcação pré-procedimento)</li>
          <li *ngIf="!photoTypeParam || photoTypeParam === 'PRE'">Fotos de <strong>pré-tratamento</strong> (antes do procedimento)</li>
          <li *ngIf="!photoTypeParam || photoTypeParam === 'IMMEDIATE_POST'">Fotos de <strong>pós-imediato</strong> (logo após o procedimento)</li>
          <li *ngIf="!photoTypeParam || photoTypeParam === 'POST'">Fotos de <strong>pós-tratamento</strong> (após o procedimento)</li>
        </ul>
        <p class="text-sm text-gray-700">
          <strong>É obrigatório adicionar pelo menos uma foto para prosseguir.</strong> Você pode capturar novas fotos
          ou selecionar da galeria.
        </p>
      </div>

      <!-- Seção de Fotos Marcação -->
      <div *ngIf="!uploadComplete && (!photoTypeParam || photoTypeParam === 'MARKING')"
        class="mb-8 border border-gray-200 rounded-lg p-6 bg-gray-50">
        <div class="flex justify-between items-center mb-4">
          <h3 class="text-xl font-semibold">Fotos de Marcação</h3>
        </div>

        <p class="text-gray-600 mb-4">Insira fotos da marcação pré-procedimento.</p>

        <div class="flex gap-2 mb-6">
          <button (click)="selectedPhotoType = 'MARKING'; addNewPhoto('MARKING')"
            class="px-4 py-2 bg-westetics-purple-800 text-white rounded-lg hover:bg-westetics-purple-600 flex items-center">
            <i class="fas fa-plus mr-2"></i>
            Adicionar Foto
          </button>
        </div>

        <div *ngIf="loading" class="my-4 text-center text-gray-500">
          <app-loading-spinner size="md" class="mx-auto mb-2"></app-loading-spinner>
          <p>Carregando fotos...</p>
        </div>

        <div class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          <div *ngFor="let photo of photos; let i = index"
            class="relative bg-gray-50 rounded-xl shadow border border-gray-200"
            [ngClass]="{'hidden': !photo.preview || photo.type !== 'MARKING'}">
            <div class="w-full h-48 flex items-center justify-center p-2 cursor-pointer">
              <img *ngIf="photo.preview" [src]="photo.preview" alt="Foto {{ photo.label }}"
                class="max-w-full max-h-full object-contain rounded-xl">
            </div>
            <div class="p-3 border-t">
              <p class="text-sm font-medium truncate">{{ photo.label }}</p>
              <button (click)="removePhoto(photo)"
                class="mt-1 px-2 py-1 text-xs bg-red-600 text-white rounded hover:bg-red-700 w-full flex items-center justify-center">
                <i class="fas fa-trash mr-1"></i>
                Remover
              </button>
            </div>
          </div>

          <div *ngIf="!hasMarkingPhotos() && !loading"
            class="col-span-full p-4 text-center text-gray-500 bg-gray-100 rounded-lg">
            <p>Ainda não há fotos de marcação. Use o botão "Adicionar Foto" acima para incluir imagens.</p>
          </div>
        </div>
      </div>

      <!-- Seção de Fotos Pré-Tratamento -->
      <div *ngIf="!uploadComplete && (!photoTypeParam || photoTypeParam === 'PRE')"
        class="mb-8 border border-gray-200 rounded-lg p-6 bg-gray-50">
        <div class="flex justify-between items-center mb-4">
          <h3 class="text-xl font-semibold">Fotos do Pré-Tratamento (ANTES)</h3>
        </div>

        <p class="text-gray-600 mb-4">Insira fotos da paciente antes do tratamento.</p>

        <div class="flex gap-2 mb-6">
          <button (click)="selectedPhotoType = 'PRE'; addNewPhoto('PRE')"
            class="px-4 py-2 bg-westetics-purple-800 text-white rounded-lg hover:bg-westetics-purple-600 flex items-center">
            <i class="fas fa-plus mr-2"></i>
            Adicionar Foto
          </button>
        </div>

        <div *ngIf="loading" class="my-4 text-center text-gray-500">
          <app-loading-spinner size="md" class="mx-auto mb-2"></app-loading-spinner>
          <p>Carregando fotos...</p>
        </div>

        <div class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          <div *ngFor="let photo of photos; let i = index"
            class="relative bg-gray-50 rounded-xl shadow border border-gray-200"
            [ngClass]="{'hidden': !photo.preview || photo.type !== 'PRE'}">
            <div class="w-full h-48 flex items-center justify-center p-2 cursor-pointer">
              <img *ngIf="photo.preview" [src]="photo.preview" alt="Foto {{ photo.label }}"
                class="max-w-full max-h-full object-contain rounded-xl">
            </div>
            <div class="p-3 border-t">
              <p class="text-sm font-medium truncate">{{ photo.label }}</p>
              <button (click)="removePhoto(photo)"
                class="mt-1 px-2 py-1 text-xs bg-red-600 text-white rounded hover:bg-red-700 w-full flex items-center justify-center">
                <i class="fas fa-trash mr-1"></i>
                Remover
              </button>
            </div>
          </div>

          <div *ngIf="!hasPrePhotos() && !loading"
            class="col-span-full p-4 text-center text-gray-500 bg-gray-100 rounded-lg">
            <p>Ainda não há fotos de pré-tratamento. Use o botão "Adicionar Foto" acima para incluir imagens.</p>
          </div>
        </div>
      </div>

      <!-- Seção de Fotos Pós-Imediato -->
      <div *ngIf="!uploadComplete && (!photoTypeParam || photoTypeParam === 'IMMEDIATE_POST')"
        class="mb-8 border border-gray-200 rounded-lg p-6 bg-gray-50">
        <div class="flex justify-between items-center mb-4">
          <h3 class="text-xl font-semibold">Fotos do Pós-Imediato</h3>
        </div>

        <p class="text-gray-600 mb-4">Insira fotos da paciente logo após o procedimento.</p>

        <div class="flex gap-2 mb-6">
          <button (click)="selectedPhotoType = 'IMMEDIATE_POST'; addNewPhoto('IMMEDIATE_POST')"
            class="px-4 py-2 bg-westetics-purple-800 text-white rounded-lg hover:bg-westetics-purple-600 flex items-center">
            <i class="fas fa-plus mr-2"></i>
            Adicionar Foto
          </button>
        </div>

        <div *ngIf="loading" class="my-4 text-center text-gray-500">
          <app-loading-spinner size="md" class="mx-auto mb-2"></app-loading-spinner>
          <p>Carregando fotos...</p>
        </div>

        <div class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          <div *ngFor="let photo of photos; let i = index"
            class="relative bg-gray-50 rounded-xl shadow border border-gray-200"
            [ngClass]="{'hidden': !photo.preview || photo.type !== 'IMMEDIATE_POST'}">
            <div class="w-full h-48 flex items-center justify-center p-2 cursor-pointer">
              <img *ngIf="photo.preview" [src]="photo.preview" alt="Foto {{ photo.label }}"
                class="max-w-full max-h-full object-contain rounded-xl">
            </div>
            <div class="p-3 border-t">
              <p class="text-sm font-medium truncate">{{ photo.label }}</p>
              <button (click)="removePhoto(photo)"
                class="mt-1 px-2 py-1 text-xs bg-red-600 text-white rounded hover:bg-red-700 w-full flex items-center justify-center">
                <i class="fas fa-trash mr-1"></i>
                Remover
              </button>
            </div>
          </div>

          <div *ngIf="!hasImmediatePostPhotos() && !loading"
            class="col-span-full p-4 text-center text-gray-500 bg-gray-100 rounded-lg">
            <p>Ainda não há fotos de pós-imediato. Use o botão "Adicionar Foto" acima para incluir imagens.</p>
          </div>
        </div>
      </div>

      <!-- Seção de Fotos Pós-Tratamento -->
      <div *ngIf="!uploadComplete && (!photoTypeParam || photoTypeParam === 'POST')"
        class="mb-8 border border-gray-200 rounded-lg p-6 bg-gray-50">
        <div class="flex justify-between items-center mb-4">
          <h3 class="text-xl font-semibold">Fotos do Pós-Tratamento (DEPOIS)</h3>
        </div>

        <p class="text-gray-600 mb-4">Insira fotos da paciente após o tratamento.</p>

        <div class="flex gap-2 mb-6">
          <button (click)="selectedPhotoType = 'POST'; addNewPhoto('POST')"
            class="px-4 py-2 bg-westetics-purple-800 text-white rounded-lg hover:bg-westetics-purple-600 flex items-center">
            <i class="fas fa-plus mr-2"></i>
            Adicionar Foto
          </button>
        </div>

        <div *ngIf="loading" class="my-4 text-center text-gray-500">
          <app-loading-spinner size="md" class="mx-auto mb-2"></app-loading-spinner>
          <p>Carregando fotos...</p>
        </div>

        <div class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          <div *ngFor="let photo of photos; let i = index"
            class="relative bg-gray-50 rounded-xl shadow border border-gray-200"
            [ngClass]="{'hidden': !photo.preview || photo.type !== 'POST'}">
            <div class="w-full h-48 flex items-center justify-center p-2 cursor-pointer">
              <img *ngIf="photo.preview" [src]="photo.preview" alt="Foto {{ photo.label }}"
                class="max-w-full max-h-full object-contain rounded-xl">
            </div>
            <div class="p-3 border-t">
              <p class="text-sm font-medium truncate">{{ photo.label }}</p>
              <button (click)="removePhoto(photo)"
                class="mt-1 px-2 py-1 text-xs bg-red-600 text-white rounded hover:bg-red-700 w-full flex items-center justify-center">
                <i class="fas fa-trash mr-1"></i>
                Remover
              </button>
            </div>
          </div>

          <div *ngIf="!hasPosPhotos() && !loading"
            class="col-span-full p-4 text-center text-gray-500 bg-gray-100 rounded-lg">
            <p>Ainda não há fotos de pós-tratamento. Use o botão "Adicionar Foto" acima para incluir imagens.</p>
          </div>
        </div>
      </div>

      <!-- Botões de ação -->
      <div *ngIf="!uploadComplete" class="flex flex-col gap-3">
        <button (click)="uploadPhotos()" [disabled]="!hasAnyPhotosForUpload() || isUploading" [ngClass]="{
          'bg-westetics-purple-800 hover:bg-westetics-purple-600': hasAnyPhotosForUpload() && !isUploading, 
          'bg-westetics-purple-300 cursor-not-allowed': !hasAnyPhotosForUpload() || isUploading
        }" class="w-full py-3 px-4 rounded-md text-white font-medium flex items-center justify-center">
          <app-loading-spinner *ngIf="isUploading" size="sm" class="mr-2"></app-loading-spinner>
          <span>{{ isUploading ? 'Enviando...' : 'Enviar Fotos' }}</span>
        </button>

        <button *ngIf="hasSelectedPhotos() && !allPhotosSelected() && !loading"
          class="text-sm text-gray-500 mt-2 underline" (click)="uploadPhotos()">
          Enviar apenas as fotos selecionadas
        </button>
      </div>

      <!-- Botão para finalizar após upload completo -->
      <div *ngIf="uploadComplete" class="flex flex-col gap-3">
        <button (click)="finish()" [disabled]="!canFinish()"
          [ngClass]="{'bg-green-600 hover:bg-green-700': canFinish(), 'bg-gray-400 cursor-not-allowed': !canFinish()}"
          class="w-full py-3 px-4 rounded-md text-white font-medium flex items-center justify-center">
          <span>{{ canFinish() ? 'Concluído' : 'Nenhuma foto enviada' }}</span>
        </button>

        <!-- Mensagem explicativa quando não é possível finalizar -->
        <div *ngIf="!canFinish()" class="text-center text-red-600 text-sm mt-2">
          <p>Para finalizar, é necessário ter enviado pelo menos uma foto.</p>
        </div>
      </div>
    </div>
  </main>

  <!-- Rodapé -->
  <footer class="bg-white border-t border-westetics-neutral-300 p-4">
    <div class="text-xs sm:text-sm text-westetics-neutral-600 text-center">
      © 2026 Westhetics. Todos os direitos reservados.
    </div>
  </footer>

  <!-- Overlay de processamento HEIC -->
  <div *ngIf="processingHeic" class="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50">
    <div class="bg-white rounded-lg p-8 max-w-xs w-full shadow-xl flex flex-col items-center">
      <app-loading-spinner size="lg" class="mb-4"></app-loading-spinner>
      <p class="text-sm text-gray-600">Processando imagem...</p>
    </div>
  </div>

  <!-- Modal para escolher entre câmera e galeria -->
  <div *ngIf="showCaptureOptions" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
    <div class="bg-white rounded-lg p-6 max-w-xs w-full">
      <div class="flex justify-between items-center mb-4">
        <h3 class="text-lg font-medium">Escolha uma opção</h3>
        <button (click)="cancelCaptureOptions()" class="text-gray-500 hover:text-gray-700">
          <span class="text-xl">&times;</span>
        </button>
      </div>

      <div class="space-y-4">
        <button *ngIf="hasCamera" (click)="captureWithCamera()"
          class="w-full flex items-center p-4 bg-westetics-purple-100 hover:bg-westetics-purple-200 rounded-lg">
          <span class="bg-westetics-purple-200 p-2 rounded-full mr-3">
            <i class="fas fa-camera text-westetics-purple-800"></i>
          </span>
          <div class="flex flex-col items-start">
            <span class="font-medium">Usar câmera</span>
            <span class="text-xs text-gray-500">Abre a câmera nativa do dispositivo</span>
          </div>
        </button>

        <button (click)="selectFromGallery()"
          class="w-full flex items-center p-4 bg-westetics-bronze-100 hover:bg-westetics-bronze-200 rounded-lg">
          <span class="bg-westetics-bronze-200 p-2 rounded-full mr-3">
            <i class="fas fa-images text-westetics-bronze-600"></i>
          </span>
          <div class="flex flex-col items-start">
            <span class="font-medium">Escolher da galeria</span>
            <span class="text-xs text-gray-500">Selecione uma foto existente</span>
          </div>
        </button>
      </div>
    </div>
  </div>
  <div *ngIf="showUploadProgress"
    class="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 p-4">
    <div class="bg-white rounded-lg p-6 max-w-md w-full shadow-xl">

      <h3 class="text-lg font-medium text-gray-900 mb-4">Enviando Fotos...</h3>

      <div class="mb-2">
        <div class="flex justify-between text-sm text-gray-600 mb-1">
          <span>Progresso Geral</span>
          <span>{{ filesUploaded }} / {{ totalFilesToUpload }}</span>
        </div>
        <div class="w-full bg-westetics-neutral-300 rounded-full h-2.5">
          <div class="bg-westetics-purple-800 h-2.5 rounded-full transition-all duration-300" [style.width.%]="uploadProgress">
          </div>
        </div>
      </div>

      <div class="mt-4 p-3 bg-gray-50 rounded-lg text-center">
        <p class="text-sm text-gray-600 mb-1">Enviando agora:</p>
        <p class="text-sm font-medium text-gray-800 truncate">{{ currentUploadingFileName }}</p>
      </div>

    </div>
  </div>
</div>